import { Controller } from "@hotwired/stimulus"

// Controls a simple tab interface for InfoBlocksComponent with progress indicator
export default class extends Controller {
  static targets = ["tab", "panel", "progress"]
  // Fallback duration (ms) if not specified per tab
  static DURATION = 9000

  connect() {
    // CSS classes
    this.hiddenClass = 'hidden'
    this.activeClass = 'bg-gray-100'
    // Build per-tab durations from data-duration-ms attribute
    this.durations = this.tabTargets.map(tab => {
      const ms = parseInt(tab.dataset.durationMs)
      return isNaN(ms) ? this.constructor.DURATION : ms
    })
    // Initialize index from data or default to 0
    const idx = parseInt(this.data.get('index')) || 0
    this.index = idx
  }

  change(event) {
    // Determine clicked tab index
    const clicked = event.currentTarget
    const idx = this.tabTargets.indexOf(clicked)
    if (idx >= 0) {
      this.index = idx
    }
  }

  showTab() {
    // Reset all progress bars
    this.progressTargets.forEach(el => {
      el.style.transition = '';
      el.style.height = '0%';
    });
    // Show the active panel, hide others
    this.panelTargets.forEach((el, i) => {
      if (i === this.index) {
        el.classList.remove(this.hiddenClass)
      } else {
        el.classList.add(this.hiddenClass)
      }
    })
    // Highlight active tab, unhighlight others
    // Highlight active tab, unhighlight others
    this.tabTargets.forEach((el, i) => {
      if (i === this.index) {
        el.classList.add(this.activeClass)
      } else {
        el.classList.remove(this.activeClass)
      }
    })
    // Animate active progress bar
    const progressEl = this.progressTargets[this.index];
    if (progressEl) {
      // Trigger reflow
      void progressEl.offsetWidth;
      // Animate progress bar to full height over this tab's duration
      const duration = this.durations[this.index]
      progressEl.style.transition = `height ${duration}ms linear`;
      progressEl.style.height = '100%';
    }
  }

  get index() {
    return parseInt(this.data.get('index')) || 0
  }

  set index(val) {
    this.data.set('index', val)
    this.showTab()
    this.scheduleNext()
  }
  
  disconnect() {
    this.stopAutoCycle()
  }

  // Schedule the next tab change based on current tab's duration
  scheduleNext() {
    this.stopAutoCycle()
    const duration = this.durations[this.index] || this.constructor.DURATION
    this._autoCycleTimer = setTimeout(() => {
      const next = (this.index + 1) % this.tabTargets.length
      this.index = next
    }, duration)
  }

  stopAutoCycle() {
    if (this._autoCycleTimer) {
      clearTimeout(this._autoCycleTimer)
      this._autoCycleTimer = null
    }
  }
}